module.exports = __webpack_public_path__ + "img/loading_big.df44dd84.gif";